// Check to see if a subcomponent of TitleLockup is passed to render paddingBottom of either titleLockupEyebrow or TitleLockupTitle
const doesChildExist = (childData, childName) => {
    /* istanbul ignore else */
    if (!childData)
        return null;
    /* istanbul ignore else */
    if (Array.isArray(childData)) {
        return (childData
            .map((child) => child && child.type && child.type.displayName
            ? child.type.displayName
            : '')
            .indexOf(childName) !== -1);
    }
    /* istanbul ignore else */
    if (typeof childData === 'object') {
        return (childData.type &&
            childData.type.displayName &&
            childData.type.displayName === childName);
    }
};

export { doesChildExist };
